import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { TourenServiceModule } from '..';
import { TourenSorterComponent } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
    TourenServiceModule
  ],
  declarations: [TourenSorterComponent],
  exports: [TourenSorterComponent],

})
export class TourenSorterComponentModule { }
